import { useRef } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

import { createCSSPreloadLinks, type RemotePageCSSAssetsResult } from './getRemotePageCSSAssets';

export type RemotePageCSSHeadProps = {
    remotePageCSSAssets: RemotePageCSSAssetsResult | null;
};

/**
 * Installs remote manifest CSS on client-side route transitions.
 * Initial page CSS is emitted from `_document` via {@link DocumentHeadAssets} so font
 * preloads stay ahead of stylesheet links; `_document` does not re-render on CSR navigation.
 */
export function RemotePageCSSHead({ remotePageCSSAssets }: RemotePageCSSHeadProps) {
    const router = useRouter();
    const initialPathname = useRef(router.pathname);
    const isClientTransition = router.pathname !== initialPathname.current;

    if (!isClientTransition || !remotePageCSSAssets) {
        return null;
    }

    return <Head>{createCSSPreloadLinks(remotePageCSSAssets)}</Head>;
}
